import { types } from '../actions/timesheets';

const initialState = {
  pending: true,
  pendingInfinityScroll: false,
  pendingDelete: false,
  error: '',
  data: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_TIMESHEETS_PENDING:
      return { ...state, pending: true, error: '' };
    case types.GET_TIMESHEETS_REJECTED:
      return { ...state, pending: false, error: action.payload.message };
    case types.GET_TIMESHEETS_FULFILLED:
      return {
        ...state,
        pending: false,
        error: '',
        data: action.payload?.Data,
        pagination: action.payload?.Pagination
      };
    case types.GET_NEXT_TIMESHEETS_PENDING:
      return { ...state, pendingInfinityScroll: true, error: '' };
    case types.GET_NEXT_TIMESHEETS_REJECTED:
      return { ...state, pendingInfinityScroll: false, error: action.payload.message };
    case types.GET_NEXT_TIMESHEETS_FULFILLED:
      return {
        ...state,
        pendingInfinityScroll: false,
        error: '',
        data: [...state.data, ...action.payload.Data],
        pagination: action.payload?.Pagination
      };
    case types.DELETE_TIMESHEET_PENDING:
      return {
        ...state,
        pendingDelete: true
      };
    case types.DELETE_TIMESHEET_REJECTED:
      return {
        ...state,
        error: action.payload.message,
        pendingDelete: false
      };
    case types.DELETE_TIMESHEET_FULFILLED:
      return {
        ...state,
        pendingDelete: false,
        data: state.data?.filter((tsheet) => tsheet.Id !== action.payload)
      };
    default:
      return state;
  }
}
